import { render, staticRenderFns } from "./IconClock3.vue?vue&type=template&id=a8e2489a&"
import script from "./IconClock3.vue?vue&type=script&lang=js&"
export * from "./IconClock3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports